import { getters, mutations } from '@/store'

export default {
  computed: {
    ...getters
  },

  methods: {
    ...mutations,
    confirmAction (message, callback) {
      this.SHOW_CONFIRM_MODAL(message)
      const isAccepted = () => {
        if (this.accepted === null && this.showConfirmModal) {
          setTimeout(isAccepted, 50)
          return
        }

        if (this.accepted === 1) {
          this.CLEAR()
          callback()
          return true
        }

        this.CLEAR()
        return false
      }

      isAccepted()
    }
  }
}
